import { render, staticRenderFns } from "./phoneIndex.vue?vue&type=template&id=b9dddc1e"
import script from "./phoneIndex.vue?vue&type=script&lang=js"
export * from "./phoneIndex.vue?vue&type=script&lang=js"
import style0 from "./phoneIndex.vue?vue&type=style&index=0&id=b9dddc1e&prod&scope=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports